module.exports = __webpack_public_path__ + "img/Google_Maps_icon.4ad67a79.svg";